import React, { useState } from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

export const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Substation', 'Renewable Energy', 'Transmission Line', 'Industrial', 'Sugar Plant'];

  const projects = [
  {
    id: 1,
    title: '220 kV Bay Extension Works',
    category: 'Substation',
    location: 'Shridhane, Maharashtra',
    capacity: '220 kV',
    year: '2024',
    status: 'Ongoing',
    description: 'Turnkey execution of 220 kV bay extension work at Shirdhane Remote End (MSETCL) for a 600 MW solar project.',
    image: 'https://customer-assets.emergentagent.com/job_ed6e21f6-4588-40b2-8743-fbb7a90d8f8d/artifacts/3skwyyzm_a04216058599091312f0df88b58f54bb.jpg'
  },
  {
    id: 2,
    title: '132/33 kV Bay Extension',
    category: 'Renewable Energy',
    location: 'Ghansawangi, Maharashtra',
    capacity: '132 kV',
    year: '2024',
    status: 'Ongoing',
    description: 'Turnkey execution of 132/33 kV bay extension work at Ghansawangi Remote End (MSETCL) for a 200 MW solar project.',
    image: 'https://images.unsplash.com/photo-1509390144018-eeaf65052242'
  },
  {
    id: 9,
    title: '3.25 MWp Rooftop Solar Project',
    category: 'Renewable Energy',
    location: 'Chhattisgarh',
    capacity: '3.25 MWp',
    year: '2024',
    status: 'Ongoing',
    description: 'Installation & Commissioning (I&C) Works including Module Erection, AC/DC Electrical Works, Cable Laying & Termination, Earthing, Testing, Pre-Commissioning, Commissioning, and Project Handover.',
    image: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?w=800&h=600&fit=crop'
  },
  {
    id: 3,
    title: '400 kV Transmission Line',
    category: 'Transmission Line',
    location: 'Bawada, Maharashtra',
    capacity: '400 kV',
    year: '2024',
    status: 'Ongoing',
    description: '400 kV transmission line execution works including erection and associated activities.',
    image: 'https://images.unsplash.com/photo-1659534198700-b52e206d8516'
  },
  {
    id: 4,
    title: '4MW / 10MWh Battery Energy Storage System (BESS)',
    category: 'Renewable Energy',
    location: 'Karnataka',
    capacity: '60 MW',
    year: '2023',
    status: 'Completed',
    description: 'Erection and installation of BESS at a solar plant in Karnataka, including associated AC/DC works and complete CEIG approval support.',
    image: 'https://customer-assets.emergentagent.com/job_ed6e21f6-4588-40b2-8743-fbb7a90d8f8d/artifacts/xe6wu0mp_BESS%201.jpg'
  },
  {
    id: 5,
    title: 'Distillery Plant E&I Works',
    category: 'Industrial',
    location: 'Karnataka',
    capacity: '200 KLPD',
    year: '2023',
    status: 'Completed',
    description: 'Supply, erection & installation of electrical systems (transformers, panels, cable laying & termination) with complete CEIG approval support.',
    image: 'https://images.unsplash.com/photo-1650668013755-9434dfd0f067'
  },
  {
    id: 6,
    title: 'Sugar Plant Electrical Systems',
    category: 'Sugar Plant',
    location: 'Solapur, Maharashtra',
    capacity: 'Multi-MW',
    year: '2023',
    status: 'Completed',
    description: 'Erection & installation of electrical systems including transformers, panels, cable laying & termination, and associated works.',
    image: 'https://images.unsplash.com/photo-1578776349090-de61da00ff1a'
  },
  {
    id: 7,
    title: '33 kV Substation',
    category: 'Substation',
    location: 'Karnataka',
    capacity: '33 kV',
    year: '2024',
    status: 'Ongoing',
    description: 'Supply, erection, installation & commissioning of electrical equipment including cable laying, DP structures, metering cubicles, lighting, and associated works.',
    image: 'https://images.unsplash.com/photo-1554050546-c125a25df013'
  },
  {
    id: 8,
    title: '132 kV Switchyard',
    category: 'Industrial',
    location: 'Madhya Pradesh',
    capacity: '132 kV',
    year: '2024',
    status: 'Ongoing',
    description: 'Erection, testing & commissioning of switchyard including transformer erection, HT/LT and control panel installation, cable laying/termination, and associated works.',
    image: 'https://images.unsplash.com/photo-1509390673020-a5b2450e33f1'
  },
  {
    id: 9,
    title: '132 KV Switchyard Work',
    category: 'Substation',
    location: 'Solapur, Maharashtra',
    capacity: '132 kV',
    year: '2024',
    status: 'Ongoing',
    description: 'Complete 132 KV switchyard erection, testing and commissioning works at Solapur, Maharashtra.',
    image: 'https://images.unsplash.com/photo-1509390484649-e8f3d1bb0b6d'
  }];


  const filteredProjects = selectedCategory === 'All' ?
  projects :
  projects.filter((project) => project.category === selectedCategory);

  return (
    <div className="min-h-screen pt-32 pb-20">
      <SEO 
        title="Projects | Calspark Electrical & Engineers"
        description="Explore Calspark's completed EPC projects including 132KV and 220KV switchyards, NHAI transmission line shifting, sugar plant cogeneration, and AVAADA renewable energy bays across Pan India."
        keywords="EPC projects India, 220KV switchyard project, AVAADA renewable energy, NHAI transmission line, tyre industry substation"
        ogUrl="/projects"
      />
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-800 to-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Projects</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Delivering excellence across diverse EPC projects throughout India
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-gradient-to-r from-teal-50 to-slate-50 border-y border-teal-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center p-4 bg-white rounded-xl shadow-sm">
              <div className="text-4xl font-bold text-teal-600 mb-2">60+</div>
              <div className="text-slate-600">Projects Completed</div>
            </div>
            <div className="text-center p-4 bg-white rounded-xl shadow-sm">
              <div className="text-4xl font-bold text-teal-600 mb-2">220 kV</div>
              <div className="text-slate-600">Max Capacity</div>
            </div>
            <div className="text-center p-4 bg-white rounded-xl shadow-sm">
              <div className="text-3xl font-bold text-teal-600 mb-2">PAN India</div>
              <div className="text-slate-600">Coverage</div>
            </div>
            <div className="text-center p-4 bg-white rounded-xl shadow-sm">
              <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
              <div className="text-slate-600">On-Time Delivery</div>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) =>
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-300 ${
              selectedCategory === category ?
              'bg-teal-600 text-white shadow-md' :
              'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'}`
              }>

                {category}
              </button>
            )}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) =>
            <div
              key={project.id}
              className="group bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">

                <div className="relative overflow-hidden h-56">
                  <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                  <div className="absolute top-4 left-4">
                    <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                      {project.category}
                    </span>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-semibold text-slate-800 mb-3 group-hover:text-teal-600 transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-slate-600 text-sm mb-4 leading-relaxed">
                    {project.description}
                  </p>

                  <div className="mb-4">
                    <div className="flex items-center gap-2 text-sm text-slate-600">
                      <MapPin className="w-4 h-4 text-teal-600" />
                      <span>{project.location}</span>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-slate-200">
                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <div className="text-xs text-slate-500">Capacity</div>
                        <div className="text-lg font-semibold text-teal-600">{project.capacity}</div>
                      </div>
                      <div>
                        <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      project.status === 'Ongoing' ?
                      'bg-amber-100 text-amber-700' :
                      'bg-green-100 text-green-700'}`
                      }>
                          {project.status}
                        </span>
                      </div>
                    </div>
                    <Link 
                      to="/contact"
                      className="inline-flex items-center gap-1 text-teal-600 font-medium text-sm hover:gap-2 transition-all"
                    >
                      View Details <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
            Have a Project in Mind?
          </h2>
          <p className="text-lg text-slate-600 mb-8">
            Let's discuss how we can bring your electrical infrastructure vision to life
          </p>
          <a
            href="/contact"
            className="inline-block bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-teal-700 transition-all duration-300 shadow-lg">

            Start Your Project
          </a>
        </div>
      </section>
    </div>);

};